import { render, staticRenderFns } from "./EventListPage.vue?vue&type=template&id=4a1b15c2&scoped=true"
import script from "./EventListPage.vue?vue&type=script&lang=js"
export * from "./EventListPage.vue?vue&type=script&lang=js"
import style0 from "./EventListPage.vue?vue&type=style&index=0&id=4a1b15c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b15c2",
  null
  
)

export default component.exports